import QRCode from 'qrcode';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';

class QrCodeController {
  public static generateQRCode(cpf: string): string|undefined {
    try {
      if (cpf) {
        let qrcode = '';
        QRCode.toDataURL(cpf, { width: 300, height: 300 }, (err, url) => {
          if (err) {
            console.error(err);
            SnackbarUtils.showMessage('Erro ao gerar Qrcode!', 'error');
          } else {
            qrcode = url;
          }
        });
        return qrcode;
      } else {
        SnackbarUtils.showMessage('CPF não encontrado!', 'error');
      }
    } catch (error) {
      SnackbarUtils.showMessage('Erro ao gerar Qrcode!', 'error');
    }
  } 
}

export default QrCodeController;
